import { render, staticRenderFns } from "./MetricsData.vue?vue&type=template&id=5dc8b043"
import script from "./MetricsData.vue?vue&type=script&lang=js"
export * from "./MetricsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports